import React from 'react';
import { getLsData, removeLsData } from '../service/lsencryption';
import { logError } from '../helpers/auth';
const history = require('history').createBrowserHistory();

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError = error => {
    return { hasError: true };
  };

  componentDidCatch(error, errorInfo) {
    console.log('inner error 1',error,errorInfo)
    var errorObj = {
      component: 'ErrorBoundary',
      method: '',
      error: error
    }
    logError(errorObj);
    this.reloadpage()
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    // You can also log error messages to an error reporting service here
  }


  componentDidMount() {
    console.log('inner error')
  }


  logout = () => {
    removeLsData('community');
    window.location.reload();
  }

  reloadpage = () => {
    let deviceuuid = getLsData('deviceuuid');
    let userObj = getLsData('obj');
    let errorScreen = window.location.href;
    if (deviceuuid && userObj) {
      history.push("#/layout/");
    } else {
      history.push("/");
    }
    setTimeout(function () {
      window.location.reload();
      window.location.href = errorScreen;
    }, 200);
  }


  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <>
        {/* <div className="container err-container">
          <div className="row">
            <div sm="12" className="col-12 my-3">
              <div color="warning" className="text-center">
                Something went wrong. Please Contact your Administrator.
              </div>
            </div>
            <div sm="12" className="col-12 my-3">
              <Button variant="contained" color="primary" onClick={() => this.reloadpage()}>Back</Button>
            </div>
          </div>
        </div> */}
        </>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;